/* import __COLOCATED_TEMPLATE__ from './team-availability-leads.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();